// extracted by mini-css-extract-plugin
export var avatarContainer = "_5c-1";
export var largeAvatarContainer = "_5c-2";
export var smallAvatarContainer = "_5c-0";